import { ProfileAboutStyledH2 } from '../styledComponents/globalStyled'
import { EducationContainer, EducationCard, EducationBody } from '../styledComponents/educationStyled'
import '../theme/core.css'
// import { Link, useHistory } from 'react-router-dom';



export default function Education() {

    //todo img source
    return (
        <>
            <ProfileAboutStyledH2>Experience</ProfileAboutStyledH2>
            <EducationContainer>
                <EducationCard>
                    <EducationBody>
                        <h4>Full Stack Developer</h4>
                        <h5> Octorber 2022 - Present · South Africa</h5>
                        <h5>AirlaForge</h5>
                        <p>Worked as a full-stack developer creating designs, mock-ups and custom Backend API's
                        </p>
                        <ul>
                            <li>Designed and implemented a scalable Express backend architecture utilizing AWS and Lambda functions, reducing backend setup time by 80% for customized APIs for clients.</li>
                            <li>Developed a specialized Android app using Kotlin, integrating custom biometric scanners for facial and fingerprint recognition. This app connected to the South African Department of Home Affairs (DHA) for real-time identity verification during enrollments.</li>
                            <li>Built a local network platform using React Native, designed for rural communities in South Africa (e.g., Diepsloot). The platform aims to provide accessible learning resources, entertainment, and community engagement. It is still in development as infrastructure is being established.</li>
                            <li>Co-founded AirlaForge, a dedicated web services branch focused on creating and maintaining websites for clients, primarily using WordPress for fast and efficient deployments.</li>
                            <li>Created an e-commerce website showcasing previous work and selling products and services. Implemented custom product payments and service requests, integrating PayFast for secure transactions.</li>
                            <li>Collaborated with designers and frontend developers to optimize the user experience for booking flights and train tickets, reducing steps from 5 to 3, following efficiency models like Booking.com.</li>
                            <li>Developed a file management system for legal professionals using TypeScript and Electron, featuring PDF editing, split-view comparison, OCR, document sharing, and advanced permission controls for administrators.</li>
                        </ul>

                    </EducationBody>
                </EducationCard>

                <EducationCard>

                    {/* <img className='educationimg' src="https://source.unsplash.com/600x400/?computer" alt="card__image" width="200" /> */}

                    <EducationBody>
                        <h4>Back-end Developer</h4>
                        <h5> Jun 2021 - Octorber 2022 · South Africa</h5>
                        <p>I worked as a Back-end Developer at Restrive, I specialize in creating robust systems from inception, collaborating seamlessly with front-end teams to integrate cohesive solutions. Working closely with other developers, my role extends to delivering both internal and external back-end applications, emphasizing design, development, and ongoing maintenance.</p>

                        <ul>
                            <li>Designed and developed a comprehensive Crypto fund platform from scratch, incorporating an additional KYC feature for enhanced security and fraud protection.</li>
                            <li>Created a logistics tracking system with differentiated permission levels, ensuring streamlined operations for the platform.</li>
                            <li>Developed an undisclosed book printing application and management system, empowering authors to upload, manage, and calculate royalties through seamless integration with our leading local eCommerce retailer.</li>
                            <li>Established secure and scalable relational databases for various applications.</li>
                            <li>Applied expertise in cyber security practices.</li>
                            <li>Managed file operations, including uploads, downloads, and content distribution.</li>
                            <li>Designed and developed a VR demo to showcase our company's capabilities to clients.</li>
                            <li>Contributed to the redesign, optimization, and ongoing maintenance of our international back-end systems.</li>
                        </ul>
                    </EducationBody>

                </EducationCard>

                <EducationCard>

                    {/* <img className='educationimg' src="https://source.unsplash.com/600x400/?computer" alt="card__image" width="200" /> */}
                    <EducationBody>
                        <h4>Freelance</h4>
                        <h5> Mar 2021 - Jun 2021 · South Africa</h5>
                        <h5> Video Game Training Tutorials with Unity</h5>
                        <p>I designed and implemented comprehensive training tutorials in Unity, tailored to instruct and guide new employees working on mining vessels. <br />The focus was on ensuring a thorough understanding of the intricacies involved in the safe and efficient operation of heavy machinery, specifically for De Beers. These tutorials not only covered fundamental aspects but also incorporated practical scenarios, enhancing the learning experience and preparing individuals for the unique challenges associated with the mining industry. The project aimed not just at imparting technical skills but also fostering a culture of safety and proficiency among the workforce.</p>
                    </EducationBody>
                </EducationCard>

                <EducationCard>

                    {/* <img className='educationimg' src="https://source.unsplash.com/600x400/?computer" alt="card__image" width="200" /> */}
                    <EducationBody>
                        <h4>Vega</h4>
                        <h5>Feb 2018 - Dec 2020</h5>
                        <h5>Virtual Reality</h5>
                        <p>In collaboration with fellow students, I led an exhibition featuring a captivating Virtual Reality Tour of Vega. Together, We co-developed this immersive experience specifically designed for the HTC Vive platform. The showcase served as a promotional initiative during Comic-Con Africa 2019, aiming to spotlight the IIE BCIS degree in Game Design and Development. Our goal was to engage and inform prospective students interested in pursuing a degree in game design at Vega.
                        </p>
                    </EducationBody>
                </EducationCard>




            </EducationContainer>
            <ProfileAboutStyledH2 id="Education">Education</ProfileAboutStyledH2>
            <ul>
                <EducationContainer>



                    <EducationCard>

                        {/* <img className='educationimg' src="https://source.unsplash.com/600x400/?computer" alt="card__image" width="200" /> */}
                        <EducationBody>
                            <h4>Online Learning & Self-Development</h4>
                            {/* <h5>
                                Matric Certificate (NSC) 2017

                                Johannesburg, South Africa
                            </h5> */}
                            <p>Continuously expanding my skills through Udemy, Codecademy, and extensive hands-on learning. I’ve dedicated countless hours to advanced tutorials, deep-dive courses, and real-world projects, ensuring I stay up to date with the latest technologies and best practices.</p>
                        </EducationBody>
                    </EducationCard>
                    <EducationCard>

                        {/* <img className='educationimg' src="https://source.unsplash.com/600x400/?computer" alt="card__image" width="200" /> */}
                        <EducationBody>
                            <h4>Curro Aurora</h4>
                            <h5>
                                Matric Certificate (NSC) 2017

                                Johannesburg, South Africa
                            </h5>
                            <p>Subjects taken during matriculation include Mathematics, English, Design, IT, CAT, and Geography. Outside of academics, I actively participated in sports, engaging in tennis and delving into football to broaden my physical and recreational pursuits.</p>
                        </EducationBody>
                    </EducationCard>

                    <EducationCard>

                        {/* <img className='educationimg' src="https://source.unsplash.com/600x400/?computer" alt="card__image" width="200" /> */}

                        <EducationBody>
                            <h4>Vega School</h4>
                            <h5>Feb 2018 - Dec 2020</h5>
                            <p> Bachelor of Computer and Information Sciences with a specialization in Computer Games and Programming Skills, <br /> where I gained a comprehensive understanding of software development, game design principles, and advanced programming techniques. The curriculum encompassed a diverse range of subjects, including algorithm design, graphics programming, and interactive systems development. This educational journey not only enhanced my technical proficiency but also nurtured my creative problem-solving abilities within the dynamic field of computer games and programming.</p>
                        </EducationBody>
                    </EducationCard>

                </EducationContainer>

            </ul>




        </>
    );
}
